import {
  primaryTextColorStyle,
  ctaTextColorStyle,
  backgroundColorStyle,
} from "~/landing-pages/shared-landing-page-styles";
import { BuildHtml } from "~/components/BuildHtml";
import { TagToClassNameMap } from "~/lib/shared/html-utils";
import { Body } from "~/ui-library";

export type WysiwygBlockProps = {
  appearance: "light" | "dark" | "brand";
  wysiwygTextField: string;
};

export const WysiwygBlock: React.FC<WysiwygBlockProps> = ({
  appearance,
  wysiwygTextField,
}) => {
  const tagToClassNameMap: TagToClassNameMap = new Map([
    ["a", ctaTextColorStyle({ appearance, className: "underline" })],
    ["p", "mb-m last:mb-0 text-body-large"],
    ["ul", "mb-m last:mb-0 ml-m text-body-large"],
    ["ol", "mb-m last:mb-0 ml-m text-body-large"],
    ["li", "list-disc list-outside mb-s last:mb-0"],
    ["p", "mb-m last:mb-0 text-body-large"],
    ["h1", "mb-m last:mb-0"],
    ["h2", "mb-m last:mb-0"],
    ["h3", "mb-m last:mb-0"],
    ["h4", "mb-m last:mb-0"],
    ["h5", "mb-xs last:mb-0"],
    ["h6", "mb-xs last:mb-0"],
    ["hr", "mb-m last:mb-0"],
  ]);

  return (
    <div className={backgroundColorStyle({ appearance })}>
      <div className="mx-auto max-w-2xl px-6 py-12 sm:py-16 lg:py-24">
        <Body
          className={primaryTextColorStyle({ appearance, className: "mt-2" })}
          size="large"
        >
          <BuildHtml
            html={wysiwygTextField}
            tagToClassNameMap={tagToClassNameMap}
          />
        </Body>
      </div>
    </div>
  );
};
